import { Item } from "./Item";
import { Box, useTheme, Typography, ButtonBase } from "@mui/material";
import Grid from "@mui/material/Grid2";

export const Card2 = ({
  title,
  items,
  justify = "center",
  padding = null,
  allowShowMore = false,
}) => {
  const theme = useTheme();
  const subtitleAlignment = justify === "start" ? "flex-start" : "center";
  const subtitlePadding = justify === "start" ? "0 0.25rem" : "0";

  // Determine padding for the container Item. If padding prop is provided,
  // keep vertical padding as theme.spacing(2) and set horizontal padding to theme.spacing(padding).
  // Otherwise, use theme.spacing(2) for all sides.
  const itemPadding =
    padding === null || padding === undefined
      ? theme.spacing(2)
      : `${theme.spacing(2)} ${theme.spacing(padding)}`;

  // Determine if items is string, and set title color accordingly.
  const titleColor = theme.palette.primary.text;
  const titleWeight = typeof items === "string" ? "normal" : "bold";

  // Convert items to an array if it is provided as a string.
  // If items is already an array, use it as-is.
  // Otherwise, default to an empty array.
  const itemsArray = Array.isArray(items)
    ? items
    : typeof items === "string"
      ? [{ subtitle: "", content: items }]
      : [];

  // When allowShowMore is false, cap/pad to three entries to preserve layout.
  const displayedItems = allowShowMore
    ? itemsArray
    : (() => {
        if (itemsArray.length === 1) {
          return [
            { subtitle: "", content: "" },
            itemsArray[0],
            { subtitle: "", content: "" },
          ];
        }
        return [
          itemsArray[0] || { subtitle: "", content: "" },
          itemsArray[1] || { subtitle: "", content: "" },
          itemsArray[2] || { subtitle: "", content: "" },
        ];
      })();

  return (
    <Item
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: itemPadding,
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        gap={0.5}
      >
        <Typography
          variant="body1"
          style={{
            color: titleColor,
            fontWeight: titleWeight,
            marginBottom: theme.spacing(1),
          }}
        >
          {title}
        </Typography>

        <Box display="flex" flexDirection="column" width="100%" gap={1}>
          {displayedItems.map((item, index) => (
            <Grid key={index}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
              >
                <Typography
                  variant="body1"
                  style={{
                    fontWeight: "lighter",
                    alignSelf: subtitleAlignment,
                    padding: subtitlePadding,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "35%",
                    color: theme.palette.primary.text2,
                  }}
                >
                  {item.subtitle}
                </Typography>
                {item.onClick ? (
                  <ButtonBase
                    onClick={item.onClick}
                    sx={{
                      maxWidth: "65%",
                      width: "65%",
                      display: "flex",
                      justifyContent: "flex-end",
                      textAlign: "right",
                      borderRadius: 1,
                      p: 0,
                    }}
                  >
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{
                        color: theme.palette.primary.main,
                        fontWeight: "medium",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.content}
                    </Typography>
                  </ButtonBase>
                ) : (
                  <Typography
                    variant="body1"
                    component="div"
                    style={{
                      color: theme.palette.primary.text2,
                      fontWeight: "medium",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "65%",
                    }}
                  >
                    {item.content}
                  </Typography>
                )}
              </Box>
            </Grid>
          ))}
        </Box>
      </Box>
    </Item>
  );
};
